import { useGlobalState, useGlobalDispatch, setUser, logoutUser } from '../context/GlobalState';
import { API_BASE_URL, setOnUnauthenticated } from '../services/httpClient';
import {useEffect} from "react";
import axios from "axios";

const loginService = async (username, password) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/api/v1/token`, {
            email_or_username: username,
            password: password,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        const data = response.data;
        localStorage.setItem('jwt_token', data.access_token);
        return data.access_token;
    } catch (error) {
        console.error('Login failed:', error);
        throw new Error('Login failed');
    }
};


export const useAuth = () => {
    const { user } = useGlobalState();
    const dispatch = useGlobalDispatch();

    const login = async (username, password) => {
        const token = await loginService(username, password);
        const userData = { username, token };
        localStorage.setItem('user', JSON.stringify(userData));
        dispatch(setUser(userData));
    };

    const logout = () => {
        localStorage.removeItem('user');
        dispatch(logoutUser());
    };

    /* Give the logout callback to the axios wrapper only once */
    useEffect(() => setOnUnauthenticated(logout), []);

    const isAuthenticated = () => Boolean(user?.token);

    return { user, login, logout, isAuthenticated };
};
